import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  Container,
  Typography,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
  Button,
  FormControl,
  FormLabel,
} from '@material-ui/core';

import { getTopic } from './messages.js';
import { avatarPic, contactEmail } from './config';

function capitalize(str) {
  return (str || '').replace(/\b[a-z]/g, function(letter) {
      return letter.toUpperCase();
  });
}

export default function TopicIntro({chatHost, avatarUrl}) {
  const { topicName } = useParams();
  const [ topic, setTopic ] = useState({});

  useEffect(() => {
    window.localStorage['start_topic'] = topicName;
    getTopic(topicName).then((topic) => setTopic(topic));
  }, [topicName]);
  
  const topicTitle = topic.title || topic.display_name || topicName;
  const topicQuestionTitle = `What specific questions do you have about ${topicTitle}?`;

  return (
    <Container component="main" maxWidth="sm">
      <Typography variant="h3">{capitalize(topicTitle)}</Typography>

      <Typography paragraph>
        Athena, our AI life coach can help you with {topicTitle} or other life topics.
      </Typography>
      
      <img style={{marginLeft: 'auto', marginRight: 'auto', display: 'block', width: '200px', marginBottom: '20px', }} src={avatarPic}></img>
      
      <Typography paragraph>
        You will have a live spoken conversation with Athena. Please <b>ensure your microphone &#127908; and speakers &#128266; are ready</b>. Try to speak clearly.
      </Typography>
      
      <form noValidate action={chatHost + '/submit-user-profile'} method="post">
        <input type="hidden" name="redirect" value={avatarUrl}/>
        <input type="hidden" name="user_agent" value={navigator.userAgent}/>

        <TextField
          variant="outlined"
          margin="normal"
          required
          fullWidth
          id="name"
          label="Name"
          name="name"
          autoComplete="name"
        />

        <TextField
          variant="outlined"
          margin="normal"
          required
          fullWidth
          id="email"
          label="Email Address"
          name="email"
          autoComplete="email"
        />

        <FormControl key="1" component="fieldset" fullWidth margin="normal">
          <FormLabel component="legend">Gender</FormLabel>
          <RadioGroup row aria-label="gender" name="gender">
            <FormControlLabel value="male" control={<Radio required />} label="Male" />
            <FormControlLabel value="female" control={<Radio required />} label="Female" />
          </RadioGroup>
        </FormControl>




        <TextField
          variant="outlined"
          margin="normal"
          fullWidth
          name="what_about_topic"
          label={topicQuestionTitle}
          multiline
          id="what_about_topic"
        />

        <Typography paragraph>
          <small>
            Your information will be kept confidential. Any advice given is not professional advice, and is for entertainment only. Please consult a professional if you are experiencing acute psychological distress or life challenges. This is an experimental AI technology.
            For more details, refer to: <a href="/terms.html" target="_blank">Terms of Use</a>, <a href="/privacy.html" target="_blank">Privacy Policy</a>, <a href={ 'mailto:' + contactEmail }>Contact</a>.
          </small>
        </Typography>

        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          style={{ margin: '24px 0' }}
        >
          Start Session
        </Button>

      </form>
    </Container>
  );
}
